import { isNotFoundError, useCustomToast } from '@/shared/lib';

export interface HomologationItemMessages {
  documentNotPending: string;
  recordNotPending: string;
  loadError: string;
}

export function warnHomologationItemNotPending(
  isRecord: boolean,
  messages: HomologationItemMessages
): void {
  useCustomToast().showWarningToast({
    title: 'Aviso',
    message: isRecord ? messages.recordNotPending : messages.documentNotPending,
    type: 'warning',
  });
}

export function notifyHomologationItemLoadFailure(
  error: unknown,
  isRecord: boolean,
  messages: HomologationItemMessages
): void {
  if (isNotFoundError(error)) {
    warnHomologationItemNotPending(isRecord, messages);
    return;
  }

  useCustomToast().showErrorToast({
    title: 'Erro',
    message: messages.loadError,
    type: 'error',
  });
}
